import React from 'react';
import { RateSummaryRevenueChart } from '../rate-summary-renevue-chart/RateSummaryRevenueChart';
import styles from './RateSummaryPerformance.module.scss';
import { AiGeneratedBadge } from 'components/ai-generated-badge/AiGeneratedBadge';
import classNames from 'classnames';

interface DataPoint {
  date: string;
  thisProperty: number;
  similarProperties: number;
}

interface RateSummaryPerformanceProps {
  rateInsights?: string[];
  revenueData: DataPoint[];
}

export const RateSummaryPerformance: React.FC<RateSummaryPerformanceProps> = ({ 
  rateInsights,
  revenueData 
}) => {
  return (
    <div className={styles.performance}>
      <div className={styles.content}>
        
        <div className={styles.header}>
          <h3>REVENUE PERFORMANCE</h3>
          <div>Compare to similar properties</div>
        </div>

        <div className={styles.body}>
          <div className={styles.insights}>
            <h4>Insights<AiGeneratedBadge/></h4>
            <ul className="slim">
              {rateInsights?.map((insight, index) => (
                <li key={index}>{insight}</li>
              ))}
            </ul>
          </div>

          <div className={styles["graph-container"]}>
            <RateSummaryRevenueChart data={revenueData} />
            <div className={styles.legend}>
              <div className={styles.item}>
                <span>This Property</span>
                <hr className={classNames(styles.color,styles["this-property"])}/>
              </div>
              <div className={styles.item}>
                <span>Similar Properties</span>
                <hr className={classNames(styles.color,styles["similar-properties"])}/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}; 